import { AgGridReact } from 'ag-grid-react';
import { useEffect } from 'react';
import useLangStore from '@/src/store/useLangStore';

type ColumnHeaderSet = {
  columnKey: string;
  ko: string;
  en: string;
};

interface UseAgGridHeaderRefreshProps {
  gridRef: AgGridReact | null;
  isReady: boolean;
  headerSet?: ColumnHeaderSet[];
}

const useAgGridHeaderRefresh = ({
  gridRef,
  isReady,
  headerSet = [],
}: UseAgGridHeaderRefreshProps) => {
  const lang = useLangStore(state => state.lang);
  useEffect(() => {
    if (!gridRef?.api?.getColumnDef) {
      return;
    }

    if (gridRef && isReady) {
      headerSet.forEach(item => {
        const transformedClassName = gridRef.api
          .getColumnDef(item.columnKey)
          ?.headerClass?.toString()
          .split(' ')
          .filter(className => className !== 'ag-header-hide')
          .join(' ');

        const columnDef = gridRef.api.getColumnDef(item.columnKey);
        if (!columnDef) return;
        if (lang === 'ko') {
          columnDef.headerName = item.ko;
        }
        if (lang === 'en') {
          columnDef.headerName = item.en;
        }
        gridRef.api.getColumnDef(item.columnKey)!.headerClass =
          transformedClassName;
      });
      gridRef?.api?.refreshHeader();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridRef, headerSet, isReady]);
};

export default useAgGridHeaderRefresh;
